export interface AiChatChristmasGiftUnlockProps {
  onClose: () => void;
}

export interface AiChatChristmasUnlockSpark {
  angleDeg: number;
  reachPx: number;
  sizePx: number;
}

export const GIFT_UNLOCK_SHOW_MS = 3400;

export const AI_CHAT_CHRISTMAS_UNLOCK_SPARKS: AiChatChristmasUnlockSpark[] = [
  {angleDeg: 0, reachPx: 170, sizePx: 12},
  {angleDeg: 30, reachPx: 140, sizePx: 17},
  {angleDeg: 60, reachPx: 180, sizePx: 22},
  {angleDeg: 90, reachPx: 150, sizePx: 12},
  {angleDeg: 120, reachPx: 175, sizePx: 17},
  {angleDeg: 150, reachPx: 135, sizePx: 22},
  {angleDeg: 180, reachPx: 165, sizePx: 12},
  {angleDeg: 210, reachPx: 145, sizePx: 17},
  {angleDeg: 240, reachPx: 180, sizePx: 22},
  {angleDeg: 270, reachPx: 150, sizePx: 12},
  {angleDeg: 300, reachPx: 170, sizePx: 17},
  {angleDeg: 330, reachPx: 140, sizePx: 22},
];
